import React from 'react'
import List from '../pages/list'

export const PagesAppsList = (props) => <List {...props} filter={{ collection: 'apps' }} title="Pages Apps" />

export default PagesAppsList
